import { render } from "./PrologueView.vue?vue&type=template&id=070b9961"
const script = {}

import "./PrologueView.vue?vue&type=style&index=0&id=070b9961&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__